var exports = {
  "i": "xaee3c4fa--d7cd31--wrapper",
};

module.exports = exports;
